module.exports = __webpack_public_path__ + "static/media/Working.3ef8c5d4.jpg";